//Load virtual Tour
$(function () {
  $("#modal-location-gallery").on("show.bs.modal", function () {
    const virtualTourLink = $(this).data("virtual-tour");
    const iframe = $(this).find("#iframe-virtual-tour")[0];

    if (iframe && !iframe.classList.contains("loaded")) {
      iframe.src = virtualTourLink;
      iframe.classList.add("loaded");
    }
  });
});
